module.exports = __webpack_public_path__ + "static/img/map3.1820f7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/map3.jpg
// module id = NzZ6
// module chunks = 1